import React, { ChangeEvent, useState, useContext, FormEvent } from 'react';
import { useHistory } from 'react-router-dom'

import OwnerContext from '../../context/OwnerContext';
import { ApiHttpServiceAnon } from '../../services/ApiServices';
import { IsMobileOrEmail } from '../../helpers/TextCheckers';
import { ErrorDanish } from '../../helpers/ErrorDanish';
import { StringValueType, OwnerLoginAttemptStatus, OwnerLoginStage } from '../../helpers/EnumsInternal';
import MainErrorText from '../../components/MainErrorText';
import { ownerLogIn } from '../../helpers/AuthOwnerHelper';


type HeaderProps = {
    setOwnerLoginStage: Function,
    showSpinner: Function,
    inputMobileOrEmail: string,
    loginCodeId: number
}

function OwnerConsentsSendCode(props: HeaderProps) {
    let {setOwnerLoginStage, showSpinner, inputMobileOrEmail, loginCodeId} = props;
    
    const ownerLoginObject = useContext(OwnerContext);
    const history = useHistory();
    const [errorText, setErrorText] = useState<string>('');
    const [codeInputFieldValue, setCodeInputFieldValue] = useState<string>('');
    const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = useState<boolean>(true);
    const [showBackButton, setShowBackButton] = useState<boolean>(false);
    

    function onInputFieldChange(inputCode: string) {
        setCodeInputFieldValue(inputCode);
        setIsSubmitButtonDisabled(inputCode === '');
    }

    
    async function handleSendCodeClick(e: FormEvent) {
        e.preventDefault()

        if (IsMobileOrEmail(inputMobileOrEmail) === StringValueType.Invalid) {
            history.push('/Error');
            return;
        }

        showSpinner(true);
        setIsSubmitButtonDisabled(true);
        setCodeInputFieldValue('');
        setErrorText('');

        await ApiHttpServiceAnon('owners/auth', 'POST',
            { LoginCodeId:loginCodeId, LoginCode:codeInputFieldValue, OwnerMobilePhoneOrEmailAddress:inputMobileOrEmail })
        .then(result => {
            // No result returned.
            if (result === undefined || result === null) {
                setErrorText(ErrorDanish["GeneralError"]);
            } else {
                switch(result.status) {
                    case 200: // OK
                    result.json()
                        .then(resultJson => {
                            // Generic write error.
                            if (resultJson === undefined || resultJson === null) {
                                setErrorText(ErrorDanish["DbFetchDataError"]);
                            // Response json received.
                            } else {
                                setIsSubmitButtonDisabled(false);
                                if (handleReturnStatusErrorAndStage(resultJson))
                                    return;
                            }
                        });
                        break;
                    case 400:   // Bad Request
                    default:
                        setErrorText(ErrorDanish['DbFetchDataError']);
                        setShowBackButton(true);
                        break;
                }
            }
            showSpinner(false);
        })
        .catch(e => {
            console.log("Something fishy happened: " + e);
            setErrorText(ErrorDanish["DbConxError"]);
            setIsSubmitButtonDisabled(false);
            setShowBackButton(true);
            showSpinner(false);
        });
    }

    function handleBackButtonClick() {
        setErrorText('');
        setOwnerLoginStage(OwnerLoginStage.Start);
    }
    
    function handleReturnStatusErrorAndStage(resultJson: any) {
        switch(resultJson.loginAttemptStatus) {
            case OwnerLoginAttemptStatus.Success:
                ownerLogIn(ownerLoginObject.setOwnerStatus, { "mobileOrEmail": inputMobileOrEmail, "token" : resultJson.token });
                setOwnerLoginStage(OwnerLoginStage.Refresh);
                return true;
            case OwnerLoginAttemptStatus.InvalidLoginCodeId:
                setErrorText(ErrorDanish["DbCodeCheckError"]);
                setShowBackButton(true);
                break;
            case OwnerLoginAttemptStatus.InvalidMobileOrEmail:
            case OwnerLoginAttemptStatus.MobileOrEmailMismatch:
                setErrorText(ErrorDanish["NoDbMatchForMobileOrEmail"]);
                setShowBackButton(true);
                break;
            case OwnerLoginAttemptStatus.LoginCodeMismatch:
                setErrorText(ErrorDanish["CodeIncorrect"] + ' ' + ErrorDanish["CodeRemainingAttempts"] + ' ' + resultJson.remainingAttempts);
                break;
            case OwnerLoginAttemptStatus.LoginCodeExpired:
                setErrorText(ErrorDanish["CodeTimeExpired"]);
                setShowBackButton(true);
                break;
            case OwnerLoginAttemptStatus.NoMoreAttempts:
                setErrorText(ErrorDanish["CodeNoMoreAttempts"]);
                setShowBackButton(true);
                break;
            default:
                setErrorText(ErrorDanish["GeneralError"]);
                setShowBackButton(true);
                break;
        }

        return false;
    }


    return (
        <form onSubmit={ handleSendCodeClick }>
            { showBackButton === false ?
                <div className="input-container">
                    <input id="ownerSendCodeValue" type="password" maxLength={6} autoFocus value={codeInputFieldValue}
                        onChange={(e: ChangeEvent<HTMLInputElement>) => onInputFieldChange(e.target.value)}></input>
                    <label htmlFor="ownerSendCodeValue" className="mr-3">Verificeringskode</label>
                    <button type="submit" className="btn btn-primary" disabled={isSubmitButtonDisabled}>Se samtykker</button>
                </div>
            :
                <div className="input-container">
                    <button type="submit" className="btn btn-warning"
                        onClick={ handleBackButtonClick }>Start forfra</button>
                </div>
            }
            { errorText !== '' && <MainErrorText errorText={errorText}  /> }
        </form>
    );
}

export default OwnerConsentsSendCode
